import { useContext } from 'react'
import { ToastContext } from '@/contexts/ToastContext'

/**
 * Custom hook to access toast notification functionality.
 *
 * This hook provides access to the showToast function from ToastContext. Must
 * be used within a ToastProvider.
 */
export function useToast() {
  const context = useContext(ToastContext)

  // Ensure hook is used within ToastProvider
  if (context === undefined) {
    throw new Error('useToast must be used within a ToastProvider')
  }

  return context
}
